export default __webpack_public_path__ + "static/media/A2_12.cff232cc.mp3";